<template>
  <div class="topfans-xingtai topfans-section app-basic-layout-wrapper">
    <div class="body">
      <div class="text-wrapper">
        <h3 class="title font-30">三大形态，助力博文效果提升</h3>
        <p class="font-color-desc">
          依托于微博的广大社交网络平台，利用微博大数据中心，以粉丝关系为核心，助力博文及品牌营销，帮你实现口碑传播和高效互动，为你匹配出最有价值的用户，积累高粘性粉丝，提高粉丝转化变现效率。
        </p>
      </div>
      <div class="card-wrapper">
        <div class="card">
          <div class="icon-image">
            <img src="@/assets/img/topfans/yingxiaotuiguang.png" alt="" />
          </div>
          <div class="icon-image active">
            <img
              src="@/assets/img/topfans/yingxiaotuiguang_active.png"
              alt=""
            />
          </div>
          <h3>营销推广</h3>
          <p class="font-13">
            博文含营销内容，希望提升粉丝数、商品销量，转化的一款工具
          </p>
          <button class="put-btn font-13">投放自己的博文</button>
        </div>
        <div class="card">
          <div class="icon-image">
            <img src="@/assets/img/topfans/neirongjiare.png" alt="" />
          </div>
          <div class="icon-image active">
            <img src="@/assets/img/topfans/neirongjiare_active.png" alt="" />
          </div>
          <h3>内容加热</h3>
          <p class="font-13">
            博文不含营销内容，希望提升曝光，增加互动和粉丝的一款工具
          </p>
          <button class="put-btn font-13">投放自己的博文</button>
        </div>
        <div class="card">
          <div class="icon-image">
            <img src="@/assets/img/topfans/bangshangtoutiao.png" alt="" />
          </div>
          <div class="icon-image active">
            <img
              src="@/assets/img/topfans/bangshangtoutiao_active.png"
              alt=""
            />
          </div>
          <h3>帮上头条</h3>
          <p class="font-13">
            为他人博文进行流量加热的一款工具，借助明星、大V影响力宣传，提升曝光量
          </p>
          <button class="put-btn font-13">帮别人投博文</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'topfans-xingtai'
}
</script>

<style lang="scss" scoped>
.topfans-xingtai {
  &.topfans-section {
    padding: 68px 0 0;
  }
  .body {
    display: flex;
  }
  .text-wrapper {
    padding-top: 76px;
    .title {
      text-align: left;
      &:after {
        left: 0;
        transform: none;
      }
    }
  }
  .card-wrapper {
    display: flex;
    align-items: center;
    margin-left: 127px;
    height: 426px;
    position: relative;
    top: 40px;
  }
  .card {
    width: 202px;
    height: 346px;
    border: 1px solid #efeff3;
    transition: all 0.2s;
    cursor: default;
    position: relative;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 28px;
    h3 {
      font-size: 20px;
      margin: 0;
    }
    p {
      display: none;
      margin-top: 16px;
      color: #ffffff;
    }
    .put-btn {
      background-color: transparent;
      color: #ffffff;
      position: absolute;
      bottom: 48px;
      height: 32px;
      padding: 0 16px;
      border: 1px solid #ffffff;
      display: none;
    }
    .icon-image {
      width: 60px;
      height: 60px;
      margin-bottom: 94px;
      img {
        max-width: 100%;
        max-height: 100%;
        object-fit: cover;
      }
      &.active {
        display: none;
      }
    }
    &:first-child {
      border-right: none;
    }
    &:last-child {
      border-left: none;
    }
    &:hover {
      height: 100%;
      background-color: $primary-color;
      border-color: $primary-color;
      box-shadow: 0 4px 12px rgba(51, 82, 254, 0.5);
      justify-content: flex-start;
      padding: 77px 28px 48px;
      .icon-image {
        display: none;
        &.active {
          display: block;
        }
        margin-bottom: 64px;
      }
      h3 {
        color: #ffffff;
      }
      p {
        display: block;
      }
      .put-btn {
        display: block;
      }
    }
  }
}
</style>
